import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import CityPageSchema from "../components/SEO/CityPageSchema";

const faqs = [
  {
    q: "How much does a website cost in Raipur?",
    a: "A basic business website in Raipur typically starts around ₹12,000–₹25,000, while ecommerce or custom web-app builds range higher depending on features. Almond Software gives a fixed quote after a free requirement call — no hidden charges."
  },
  {
    q: "How long does it take to build a website?",
    a: "Most business websites are delivered in 7–15 days. Ecommerce stores (Shopify) and custom React applications usually take 3–5 weeks depending on scope."
  },
  {
    q: "Do you provide website maintenance after delivery?",
    a: "Yes. We offer monthly and annual maintenance plans covering updates, security patches, backups and content changes for clients across Raipur."
  }
];

export default function RaipurLanding() {
  return (
    <>
      <Helmet>
        <title>Website Development Company in Raipur | Almond Software</title>
        <meta
          name="description"
          content="Almond Software is a website development company in Raipur building fast React websites, Shopify stores & custom software for local businesses. Free quote in 24 hours."
        />
        <link
          rel="canonical"
          href="https://almondsoftwares.in/website-development-company-raipur"
        />
        <meta
          property="og:title"
          content="Website Development Company in Raipur | Almond Software"
        />
        <meta
          property="og:description"
          content="React, Shopify & custom software development for businesses in Raipur, Chhattisgarh."
        />
        <meta
          property="og:image"
          content="https://almondsoftwares.in/logo192.png"
        />
        <meta
          property="og:url"
          content="https://almondsoftwares.in/website-development-company-raipur"
        />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <CityPageSchema
        city="Raipur"
        slug="website-development-company-raipur"
        faqs={faqs}
      />

      <div className="bg-luxury" />

      {/* HERO */}
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <h1>Website Development Company in Raipur</h1>
            <p className="hero-glow">
             Almond Software builds high-performance websites, ecommerce stores, and custom software solutions for businesses in Raipur,Nagpur,Mumbai and clients worldwide.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn-primary">
                Get a Free Quote
              </Link>
              <Link to="/creations" className="btn-secondary">
                See Our Work
              </Link>
            </div>
            <div className="msme-badge">
              <span className="blue-tick">✓</span>
              Trusted by businesses across Raipur &amp; Chhattisgarh
            </div>
          </div>

          <div className="hero-visual">
            <div className="floating-card">
              <h3>Why Raipur businesses choose us</h3>
              <ul style={{ marginTop: 20, lineHeight: 2, color: "#475569" }}>
                <li>✅ Local team — Raipur based, not outsourced</li>
                <li>✅ Websites built for Google ranking, not just looks</li>
                <li>✅ React, Shopify &amp; Salesforce expertise</li>
                <li>✅ Ongoing support after launch</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="section container">
        <h2 className="section-title">Our Services in Raipur</h2>
        <div className="services">
          <div className="service-card">
            <i className="fa-solid fa-code" />
            <h3>Business Websites</h3>
            <p>
              Fast, mobile-friendly React websites for shops, clinics,
              consultants and local businesses in Raipur that need to look
              professional and rank on Google.
            </p>
          </div>
          <div className="service-card">
            <i className="fa-solid fa-cart-shopping" />
            <h3>Ecommerce &amp; Shopify</h3>
            <p>
              Online stores for Raipur brands ready to sell beyond their
              local shop — built on Shopify or fully custom carts with
              payment gateway integration.
            </p>
          </div>
       
        </div>
      </section>

      {/* PROCESS */}
      <section className="section container">
        <h2 className="section-title">How We Work</h2>
        <div className="process">
          <div>1. Free consultation call</div>
          <div>2. Design &amp; content plan</div>
          <div>3. Build &amp; review</div>
          <div>4. Launch &amp; SEO setup</div>
          <div>5. Ongoing support</div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section container">
        <h2 className="section-title">Common Questions</h2>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          {faqs.map((f, i) => (
            <div
              key={i}
              className="service-card"
              style={{ marginBottom: 20, cursor: "default" }}
            >
              <h3 style={{ fontSize: 20 }}>{f.q}</h3>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="section container">
        <div className="more-projects">
          <h2>Ready to build your website in Raipur?</h2>
          <p style={{ color: "#475569", marginTop: 12 }}>
            Talk to our team today — free quote, no obligation.
          </p>
          <div style={{ marginTop: 28 }}>
            <Link to="/contact" className="btn-primary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}